import { useQuery } from "@tanstack/react-query";
import autoAssignService from "../../../../services/web/auto-assign-service";

function normalizeSignedAlarmsResponse(data) {
    if(!data) return { rows: [] };

    const rows = Array.isArray(data) ? data : Array.isArray(data?.content) ? data.content : [];
    
    return { rows };
}

async function fetchSignedAlarms({ queryKey }) {
    const [_key, autoAssignId] = queryKey;

    if (!autoAssignId) { return normalizeSignedAlarmsResponse(null); }

    const data = await autoAssignService.signedAlarms(autoAssignId);

    return normalizeSignedAlarmsResponse(data);
}

export function useSignedAlarmListQuery(autoAssignId) {
    return useQuery({
        queryKey: ["signedAlarms", autoAssignId],
        queryFn: fetchSignedAlarms,
        enabled: !!autoAssignId,
    });
}